export default "__VITE_ASSET__C394bWsm__"